export const catEstatusCambioPasajero = Object.freeze({
    NO_APLICA: 0,
    VALIDA_DISPONIBILIDAD: 1,
    MONTO_REQUERIDO: 2,
    PAGADO: 3,
    ACEPTADO_CLIENTE: 4,
    SIN_DISPONIBILIDAD: 5,
    NO_PAGADO: 6,
    RECHAZADO_CLIENTE: 7
})